import {PLACE_COLORS} from "../../../../constants/index.jsx";
import Button from "../../../../core/Button/Button.jsx";
import {useTranslation} from "react-i18next";
import {roomJoinToView} from "../../../../redux/actions/rooms/actions.js";
import {useDispatch, useSelector} from "react-redux";
import {closeLobbyModal, selectActiveRoomTab} from "../../../../redux/actions/lobby/actions.js";

function TournamentParticipantItem({item}) {
    const placeClass = PLACE_COLORS[item.place] || ''
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const room = useSelector(state => state.rooms?.[item?.roomId]) || {};
    const onClick = () => {
        if (room?.roomId === item?.roomId) {
            dispatch(selectActiveRoomTab({roomId: item?.roomId}))
        } else {
            dispatch(roomJoinToView({roomId: item?.roomId}))
        }
        dispatch(closeLobbyModal());
    }

    return (
        <li className="tournament-info-players--item">
            <p className={`tournament-info-players--item--cell ${placeClass ? "place" : ""}`}>
                <span className={placeClass}>{item.place}</span>
            </p>
            <p className="tournament-info-players--item--cell">
                <span>{item.platformId}</span>
            </p>
            {
                item.status === "PROGRESS" ?
                    <Button type="blue-border" text={t("buttons.view")}
                            onClick={() => onClick()}/> :
                    <p className="tournament-info-players--item--cell">
                        <span>-</span>
                    </p>
            }
        </li>
    )
}

export default TournamentParticipantItem